import {makeStyles} from "@material-ui/core";

export const useStyles = makeStyles({
  close: {maxHeight: 0},
  open: {maxHeight: 10000},
});